import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { LEADERS } from "@/content";
import { MaskLines, Overline, Reveal } from "@/components/site/Reveal";
import { SectionBackdrop } from "@/components/site/BgFade";

const LeaderCard = ({ l, i }) => (
  <Reveal delay={i * 0.15} className="h-full">
    <motion.article
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
      className="group relative flex h-full flex-col overflow-hidden rounded-[28px] border border-rc-line bg-rc-surface/40 p-8 backdrop-blur-[2px] sm:p-10"
      data-testid={`leader-card-${i}`}
    >
      <span className="pointer-events-none absolute -right-6 -top-16 select-none font-display text-[260px] italic leading-none text-outline opacity-60 transition-transform duration-700 group-hover:-translate-x-4 sm:text-[320px]">
        {l.initial}
      </span>
      <Overline>{l.role}</Overline>
      <h3 className="relative mt-24 font-display text-4xl font-medium text-rc-ink sm:mt-32 sm:text-5xl">{l.name}</h3>
      <p className="relative mt-3 font-mono-rc text-xs uppercase tracking-[0.2em] text-rc-muted">{l.craft}</p>
      <p className="relative mt-8 text-base leading-relaxed text-rc-body">{l.bio}</p>
      <a
        href={l.url}
        target="_blank"
        rel="noopener noreferrer"
        className="relative mt-auto inline-flex w-fit items-center gap-2 pt-10 text-sm text-rc-copper transition-colors hover:text-rc-glow"
        data-testid={`leader-instagram-${i}`}
      >
        <Instagram className="h-4 w-4" /> {l.social}
      </a>
    </motion.article>
  </Reveal>
);

export const Leadership = () => (
  <section id="leadership" className="relative overflow-hidden bg-rc-bg2 py-28 lg:py-40" data-testid="leadership-section">
    <SectionBackdrop photos={["/images/couple-portrait-1.webp", "/images/couple-portrait-2.webp"]} testId="leadership-bg" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <Overline>Our Leadership</Overline>
          <MaskLines
            lines={["Two voices,", <><em className="italic text-rc-copper">one</em> shared calling.</>]}
            className="mt-8 font-display text-4xl font-medium leading-[1.02] tracking-tight text-rc-ink sm:text-5xl lg:text-6xl"
          />
        </div>
        <Reveal className="max-w-md text-base leading-relaxed text-rc-body">
          Together, they lead The Rhett Co with a shared commitment to creativity, leadership development, and serving the church and creative community.
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
        {LEADERS.map((l, i) => (
          <LeaderCard key={l.name} l={l} i={i} />
        ))}
      </div>
    </div>
  </section>
);
